import React from 'react';
import { Tag } from 'antd';

class CourseDurationTag extends React.Component {
    getDurationText = (duration) => {
        if(!duration){
            return 'El curso no cuenta con duración asignada'
        }
        return `Duración del curso: ${duration} ${(duration === 1) ? 'mes' : 'meses'}`
    }

    render(){
        const {
            courseDuration,
            className,
            color
        } = this.props;

        return(
            <Tag 
                className={`${className}`} 
                color={color}
            >
                {this.getDurationText(courseDuration)}
            </Tag>
        )
    }
}
export default CourseDurationTag;